import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidMobileNumber = (mobile_number) => {
  if (
    isNull(mobile_number) ||
    isUndefined(mobile_number) ||
    incorrectDataType(mobile_number, 'string') ||
    hasWhitespacesOnly(mobile_number) ||
    isEmpty(mobile_number)
  ) {
    return false;
  } else {
    const regex_mobile = new RegExp('^[6789][0-9]{9}$');
    return regex_mobile.test(mobile_number);
  }
};
